const filterDefault = {
  specialty: null,
  location: null,
  tenant: null,
  professional: null,
  date: null,
  local: null
}

export default {
  professionals: [],
  schedules: [],
  schedulesToAddTime: [],
  specialties: [],
  medicalInsurances: [],
  attendances: [],
  datasAgenda: [],
  local: [],
  individuals: [],
  agendamentosSgh: [],
  endereco: null,
  logo: null,
  user: null,
  userCpfDigital: null,
  status: [],
  profissionaisAgenda: [],
  telehealth: false, // true = online, false = presencial (controla botão selecionado)
  cities: [],
  tipoAgendamentoSgh: false,
  appointmentTypes: [],
  // Permissão vinda do FourHealth (header do /login-digital): controla o botão "Incluir horário extra".
  // Default false → botão oculto até o backend confirmar a role appointment:IncluirHorarioExtra.
  podeIncluirHorarioExtra: false
}
